import {
  CycleTime,
  getAccountedCycleTime
} from 'views/root/views/home/views/activity/views/branchesV2/cycleTimeUtil';
import { StyledCell } from '../../Table.style';
import { useContext } from 'react';
import MetricsInspectionContext from '../../../../state/context';
import { metricNames } from '@linearb/linjs-common';
const AccountedCycleTimeCell = ({ branch }) => {
  const {
    state: { branchesCycleTimeStages, metricName }
  } = useContext(MetricsInspectionContext);

  if (metricName !== metricNames.CYCLE_TIME) {
    return <></>;
  }
  const cycleTimeStages = branchesCycleTimeStages[branch.id] || [];

  const accountedCycleTime = getAccountedCycleTime(
    cycleTimeStages,
    branch.stats
  );

  return (
    <StyledCell data-testid='cycle-time-metric-value'>
      <CycleTime
        subtitle='Accounted Cycle Time excludes metric elements that are outside the boundaries of the filtered time frame.'
        included_stages={cycleTimeStages}
        branchData={{
          ...branch,
          cycle_time: accountedCycleTime
        }}
      />
    </StyledCell>
  );
};

export default AccountedCycleTimeCell;
